<template>
  <div class="terminus-header-wrapper">
    <div class="terminus-header">
      <div class="terminus-header__left">
        <div class="terminus-header__left-top">
          <router-link class="terminus-header__logo" to="/" exact></router-link>
          <v-btn
            @click="drawer = !drawer"
            icon
            class="terminus-sidebar-drawer"
            elevation="0"
          >
            <v-icon color="primary">
              {{ drawer ? "$sidebar_close" : "$menu" }}
            </v-icon>
          </v-btn>
        </div>
      </div>
      <div class="terminus-header__right">
        <div class="nav-block">
          <router-link class="terminus-header-nav__link" to="/gta">
            GTA Nominees
          </router-link>
          <router-link class="terminus-header-nav__link" to="/jury">
            Jury Award Winners
          </router-link>
          <router-link class="terminus-header-nav__link" to="/socials">
            #CMFTerminus2021
          </router-link>
          <router-link class="terminus-header-nav__link" to="/birthday">
            Happy Birthday CMF
          </router-link>
          <a
            class="terminus-header-nav__link"
            href="https://campusmoviefest.com/terminus/about"
          >
            About
          </a>
        </div>
      </div>
    </div>
    <TerminusSidebar v-model="drawer" :collapsed="collapsed" />
  </div>
</template>

<script>
export default {
  props: {
    collapsed: Boolean
  },
  data() {
    return {
      drawer: false,
      countdown: {
        release_date: "2021-06-22T13:00:00.000-04:00"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.terminus-header {
  display: flex;
  border-color: $primary;
  border-width: 2px 0;
  border-style: solid;
  &-wrapper {
    width: 100%;
    background-image: url("~@/assets/bg.jpg") !important;
    background-size: 100%;
    background-position: center -70px;
  }
  &__left {
    flex-basis: 410px;
    min-width: 410px;
    border-right: 2px solid $primary;

    @media screen and (max-width: 1264px) {
      min-width: 28%;
      flex-basis: unset;
    }
  }
  &__left-top {
    min-height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__left-bottom {
    border-top: 2px solid $primary;
    overflow: hidden;
    transition: 0.3s;
    height: 82px;
    &.collapsed {
      height: 0;
      margin-bottom: -2px;
    }
  }
  &__logo {
    min-height: 80px;
    background-image: url("~@/assets/terminus-header-logo.svg");
    background-repeat: no-repeat;
    background-position: 0 center;
    background-size: 202.5px 45px;
    flex-grow: 1;
    margin-left: 120px;
  }
  &__right {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 1em;
    .nav-block {
      text-align: center;
      > * {
        display: inline-block;
        font-size: 18px;
        margin: 0 1em;
      }
      > a {
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
        &.router-link-active {
          color: $cmf-orange;
          cursor: default;
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
}

.terminus-sidebar-drawer {
  display: none;
}

@media screen and (max-width: 1264px) {
  .terminus-header {
    &__logo {
      margin-left: 56px;
    }
  }
}

@media screen and (max-width: 960px) {
  .terminus-header {
    flex-direction: column;
    &__left {
      border-right: 0;
      flex-basis: unset;
    }
    &__left-top {
      padding: 0 13px 0 25px;
    }
    &__logo {
      margin-left: 0;
      background-size: 135px 30px;
      background-position: 0 center;
    }
    &__right {
      display: none;
    }
  }

  .terminus-sidebar-drawer {
    display: block !important;
  }
}
</style>
